import type { UserManagerSettings } from 'oidc-client-ts';

export const userManagerConfig: UserManagerSettings = {
  authority: `${process.env.KEYCLOAK_URL}`,
  client_id: `${process.env.KEYCLOAK_CLIENT_ID}`,
  redirect_uri: window.location.origin,
  silent_redirect_uri: `${window.location.origin}/silent-redirect.html`,
  automaticSilentRenew: false,
  silentRequestTimeoutInSeconds: 10,
  revokeTokensOnSignout: true,
};
